<!--
 * @Author: yindengli
 * @Date: 2023-09-26 16:17:51
 * @LastEditTime: 2023-10-19 16:40:20
 * @LastEditors: yindengli
 * @Description: 
 * @FilePath: \openseeyon-index-front\src\components\login\code-item.vue
-->
<template>
  <div class="code">
    <div class="item graph-code">
      <div class="title">图形验证</div>
      <a-input class="input-item" v-model="graphValue" placeholder="请输入右侧图形的计算结果" />
      <img class="img-code" :src="base64Code">
      <div @click="getCodeImage" class="sx-link"></div>
    </div> 
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    codeUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      graphValue: "", // 图形验证码
      base64Code: "", // 图片验证码
      codeKey: "",
    }
  },
  created() {
    this.getCodeImage();
  },
  methods: {
    getCodeValue() {
      return {
        graphValue: this.graphValue,
        codeKey: this.codeKey
      }
    },
    /**
     * 获取图形验证码
     */
    getCodeImage(){
      axios({
        url: this.codeUrl
      }).then(res=>{
        if (res && res.data && res.data.data) {
          this.base64Code = res.data.data.image;
          this.codeKey = res.data.data.codeKey;
        }
      },err=>{
          console.log(err)
      })
    },
  }
}
</script>

<style scoped>
.code, .item {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  width: 100%;
  height: 50px;
}
.sx-link {
  width: 70px;
  height: 50px;
  background: url("@/assets/imgs/icon3.png") no-repeat center;
  margin-left: 10px;
}
.sx-link:hover {
  transform: rotate(180deg);
  transition: all 0.3s ease;
}
.title {
  width: 80px;
  max-width: 80px;
  min-width: 80px;
  line-height: 52px;
  display: block;
  float: left;
  font-size: 16px;
  text-align: right;
  padding-right: 4px;
}
.img-code {
  margin-left: 10px;
  /* margin-bottom: 12px; */
}
.input-item {
  border: 1px solid #d7d7d7;
  background: #f7f7f7;
  padding: 0 15px;
  line-height: 48px;
  height: 50px;
  overflow: hidden;
  position: relative;
  width: 100%;
}


@media screen and (max-width: 1024px) {
  .input-item {
    height: 40px;
  }
  .title {
    font-size: 14px;
    max-width: 60px;
    min-width: 60px;
    line-height: 40px;
    text-align: right;
    padding-right: 3px;
  }
  .img-code {
    width: 60px;
    height: 25px;
    margin-top: 5px;
    margin-left: 5px;
  }
  .sx-link {
    width: 30px;
    height: 22px;
    background-image: url("@/assets/imgs/icon3.png") ;
    background-size:100% 100%;
    margin-left: 5px;
     margin-top: 7px;
  }
}
</style>